var map = {
	"./freshwater/arapaima/vector.png": "2ef4",
	"./freshwater/beluga-sturgeon/vector.png": "c8c0",
	"./freshwater/chinook-salmon/vector.png": "8718",
	"./freshwater/goldfish/vector.png": "1d05",
	"./freshwater/koi-carp/vector.png": "fcb7",
	"./freshwater/red-bellied-piranha/vector.png": "c717",
	"./freshwater/redtail-catfish/vector.png": "8990",
	"./freshwater/smalltooth-sawfish/vector.png": "b917",
	"./ocean/bottlenose-dolphin/vector.png": "e60e",
	"./ocean/box-jellyfish/vector.png": "18a0",
	"./ocean/giant-pacific-octopus/vector.png": "f6c4",
	"./ocean/gray-seal/vector.png": "ff34",
	"./ocean/green-sea-turtle/vector.png": "091e",
	"./ocean/humboldt-penguin/vector.png": "9882",
	"./ocean/manta-ray/vector.png": "9124",
	"./ocean/starfish/vector.png": "e63a",
	"./saltwater/atlantic-tarpon/vector.png": "a914",
	"./saltwater/butterflyfish/vector.png": "ed8a",
	"./saltwater/clownfish/vector.png": "d0aa",
	"./saltwater/emperor-angelfish/vector.png": "ebeb",
	"./saltwater/hippo-tang/vector.png": "8c51",
	"./saltwater/longhorn-cowfish/vector.png": "4917b",
	"./saltwater/red-lionfish/vector.png": "0919",
	"./saltwater/yellow-surgeonfish/vector.png": "bc3b",
	"./shark/blacktip-shark/vector.png": "b693",
	"./shark/bull-shark/vector.png": "a844",
	"./shark/nurse-shark/vector.png": "3c24",
	"./shark/oceanic-whitetip-shark/vector.png": "bbe9",
	"./shark/pelagic-thresher-shark/vector.png": "a168",
	"./shark/scalloped-hammerhead-shark/vector.png": "72c4",
	"./shark/whale-shark/vector.png": "40a8",
	"./shark/zebra-shark/vector.png": "63af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f5f4";